import { render, staticRenderFns } from "./CreateMixCampaign.vue?vue&type=template&id=b0f16088&scoped=true&"
import script from "./CreateMixCampaign.vue?vue&type=script&lang=ts&"
export * from "./CreateMixCampaign.vue?vue&type=script&lang=ts&"
import style0 from "./CreateMixCampaign.vue?vue&type=style&index=0&id=b0f16088&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f16088",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0f16088')) {
      api.createRecord('b0f16088', component.options)
    } else {
      api.reload('b0f16088', component.options)
    }
    module.hot.accept("./CreateMixCampaign.vue?vue&type=template&id=b0f16088&scoped=true&", function () {
      api.rerender('b0f16088', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/CreateMixCampaign.vue"
export default component.exports